
<style scoped lang="less">
#account-recharge-content {
  margin-bottom: @containerGap;
  .amount-items-info {
    width: 100%;
    .amount-arr-style {
      .display-flex(center, flex-start);
      flex-wrap: wrap;
      font-size: 17px;
      color: @textColorLight;
      gap: 10px;
      .item-cell {
        .flex-grow(23%);
        height: @formHeight;
        line-height: @formHeight;
        background-color: @backColorNormal;
        border: 1px solid @lineColorNormal;
        border-radius: 6px;
        cursor: pointer;
        text-align: center;
        &.is-current {
          background-color: @themeColor;
          color: white;
        }
      }
    }
    .no-amount-arr {
      color: @textColorNormal;
      font-size: 14px;
      font-weight: normal;
    }
  }
}
</style>

<template>
  <div id="account-recharge-content">
    <Form>
      <FormItem
        v-for="(item, index) in formItems"
        :key="index"
        :label="item.label"
        :label-width="100"
        :required="item.isRequired"
      >
        <div
          v-if="item.tagName === 'AmountSelect'"
          class="amount-items-info"
        >
          <div
            v-if="amountArr.length"
            class="amount-arr-style"
          >
            <div
              v-for="(re, ind) in amountArr"
              :key="ind"
              class="item-cell"
              :class="currentIndex === ind ? 'is-current' : ''"
              @click.stop="_clickItem(ind)"
            >
              {{ re.moneyName }}
            </div>
          </div>
          <div
            v-else
            class="no-amount-arr"
          >
            暂未配置充值金额
          </div>
        </div>
        <div v-else>
          <div>{{ model[item.key] || '-' }}</div>
        </div>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import UserApiSet from '@/request/api/UserApiSet';

export default {
  components: {},
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      // 表单数据
      formItems: [
        {
          label: '充值金额',
          key: 'money',
          tagName: 'AmountSelect',
          disabled: false,
          isRequired: true
        },
        {
          label: '充值账户',
          key: 'tel',
          tagName: 'Div',
          disabled: false,
          isRequired: true
        },
        {
          label: '支付渠道',
          key: 'payChannel',
          tagName: 'Div',
          disabled: false,
          isRequired: true
        }
      ],
      amountArr: [],
      currentIndex: -1
    };
  },
  created () {
    console.log(this.model);
    this.$nextTick(() => {
      // 请求充值金额列表
      this.requestMoneyList();
    });
  },
  methods: {
    /** ******************* 回调事件开始 ******************* **/
    // 检查必填项
    checkSubmit () {
      if (!this.amountArr.length) {
        this.$emit('on-change', {
          disabled: true,
          msg: '暂未配置充值金额，请稍后重试'
        });
        return;
      }
      const item = this.formItems.find(v => v.isRequired && !this.model[v.key]);
      this.$emit('on-change', {
        disabled: !!item,
        msg: item ? (item.label + '不可为空') : ''
      });
    },
    onClose () {
      this.$emit('on-close');
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    // 点击金额
    _clickItem (index) {
      console.log(index, this.currentIndex);
      if (index === this.currentIndex) {
        this.currentIndex = -1;
        this.model.money = '';
      } else {
        this.currentIndex = index;
        this.model.money = this.amountArr[index].moneyValue;
      }
      this.checkSubmit();
    },
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    // 请求充值金额列表
    requestMoneyList () {
      const api = UserApiSet.getMoneyList;
      console.log(api);
      this.$http(api).then(res => {
        console.log(res);
        this.amountArr = res.data.rows;
        this.checkSubmit();
      });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
